import { buildColor } from "@tvg/design-system";
import styled, { css, keyframes } from "styled-components";

export const Wrapper = styled.div<{
  pillsDistanceFromTop: number;
}>`
  position: sticky;
  top: ${({ pillsDistanceFromTop }) => pillsDistanceFromTop}px;
  background-color: ${({ theme }) => theme.colorTokens.background.surface};
  z-index: 2;
`;

export const SelectionWrapper = styled.div<{ hasTransitionFinished: boolean }>`
  width: 100%;
  position: relative;
  visibility: ${({ hasTransitionFinished }) =>
    hasTransitionFinished ? `hidden` : `visible`};
`;

export const Selection = styled.div<{ width: number; left: number }>`
  position: absolute;
  width: ${({ width }) => width}px;
  height: 32px;
  top: 8px;
  left: ${({ left }) => left}px;
  border-radius: 25px;
  background-color: ${({ theme }) =>
    theme.colorTokens.component.button.buttonLink.content.base};
  transition: left 0.5s ease, width 0.5s ease;
`;

export const ScrollingMaskWrapper = styled.div`
  width: 100vw;
  height: 48px;
  position: relative;
  display: flex;
`;

export const ScrollingMask = styled.div`
  width: 100vw;
  height: 100%;
  top: 0;
  right: 0;
  position: absolute;
  ${({ theme }) =>
    css`
      background: linear-gradient(
        270deg,
        ${theme.colorTokens.background.surface} 0%,
        rgba(5, 40, 90, 0) 20%
      );
    `};
  z-index: 2;
  pointer-events: none;
`;

export const ButtonsWrapper = styled.div<{ scrollingMaskOffset: number }>`
  position: relative;
  display: flex;
  padding: ${({ theme }) => theme.space["space-3"]};
  overflow-y: scroll;
  box-shadow: ${({ theme }) => theme.elevations.medium};

  & > div:last-child {
    button {
      margin-right: ${({ scrollingMaskOffset }) => scrollingMaskOffset}px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  height: 32px;
  button {
    height: inherit;
    padding: ${({ theme }) => theme.space["space-3"]};
    border-radius: 25px;
  }
`;

export const ButtonLabel = styled.span<{ isActive: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.s};
  white-space: nowrap;
  color: ${({ theme, isActive }) =>
    isActive
      ? theme.colorTokens.component.button.primary.content.base
      : theme.colorTokens.component.button.buttonLink.content.base};
  transition: color 1s ease;
`;

export const pulseAnimation = keyframes`
  0% {
    fill: ${buildColor("blue", "000")};
  }
  
  50% {
    fill: ${buildColor("blue", "100")};
  }
  
  100% {
    fill: ${buildColor("blue", "000")};
  }
`;

export const SVG = styled.svg`
  rect {
    animation: ${pulseAnimation} 1.25s infinite;
  }
`;
